import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

import { Campaign } from '../../models/campaign.model';

@Pipe({name: 'kgCampaignName'})
export class CampaignNamePipe implements PipeTransform {

  public transform(campaign: Campaign): string {
    return 'Ligne ' + campaign.line.name + ' | '
      + this.formatDate(campaign.startDate) + ' - '
      + (campaign.endDate ? this.formatDate(campaign.endDate) : 'En cours');
  }

  private formatDate(dateString: string) {
    let dateMoment = moment(dateString, "YYYY-MM-DD HH:mm:ss");
    return dateMoment.format('DD/MM/YYYY')
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/campaign-name.pipe.ts